import React from "react";

const HoursText = ({ hours }) => {
    return (
        <div className="table-responsive">
            <table className="table table-striped align-middle">
                <thead>
                <tr>
                    <th>Day</th>
                    <th>Time</th>

                    <th>Status</th>
                    <th>Note</th>
                </tr>
                </thead>
                <tbody>
                {hours.map((h, idx) => (
                    <tr key={idx}>
                        <td>{h.day}</td>
                        <td>{h.start} - {h.end}</td>

                        <td>{h.status ? "Open" : "Closed"}</td>
                        <td>{h.note || "—"}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default HoursText;
